import { Box } from "@/Components/v2/atoms/Box";
import { Button } from "@/Components/v2/atoms/Button";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";

type NoEligibleScenariosProps = {
  onClick: () => void;
  handleClose: () => void;
  isLoading: boolean;
};
export const NoEligibleScenarios = ({
  onClick,
  handleClose,
  isLoading,
}: NoEligibleScenariosProps) => (
  <Box p={2}>
    <Stack spacing={3}>
      <Typography variant="h5" fontWeight={600}>
        No eligible scenarios
      </Typography>
      <Typography variant="body2">
        We couldn&apos;t find any scenarios that can be converted into Action Plans. This may be
        because they have failed to simulate or are still simulating.
      </Typography>
      <Typography variant="body2">
        Please create a new scenario or contact your Marketing Science Partner for assistance.
      </Typography>
      <Stack direction="row" justifyContent="flex-end" spacing={3}>
        <Button
          variant="text"
          onClick={handleClose}
          sx={{ borderRadius: 50, textTransform: "none" }}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          onClick={onClick}
          disabled={isLoading}
          sx={{ borderRadius: 50, textTransform: "none" }}
        >
          Create Scenario
        </Button>
      </Stack>
    </Stack>
  </Box>
);
